package com.essntl.core.quickbooks.data

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class QuickbooksCustomerDto(
    val Customer: QuickbooksCustomer,
    val time: String,
)

@Serializable
data class QuickbooksCustomer(
    @SerialName("PrimaryEmailAddr")
    val primaryEmailAddr: PrimaryEmailAddr? = null,
    val SyncToken: String,
    val domain: String,
    val GivenName: String?,
    val DisplayName: String,
    val BillWithParent: Boolean,
    val FullyQualifiedName: String,
    val CompanyName: String? = null,
    val FamilyName: String? = null,
    val sparse: Boolean,
    @SerialName("PrimaryPhone")
    val primaryPhone: PrimaryPhone? = null,
    val Active: Boolean,
    val Job: Boolean,
    val BalanceWithJobs: Double,
    @SerialName("BillAddr")
    val billAddr: CustomerBillAddr? = null,
    val PreferredDeliveryMethod: String,
    val Taxable: Boolean,
    val PrintOnCheckName: String,
    val Balance: Double,
    val Id: String,
    val MetaData: CustomerMetaData,
    val time: String? = null,
) {
    companion object {
        val empty = QuickbooksCustomer(
            Id = "",
            primaryEmailAddr = PrimaryEmailAddr(
                Address = "",
            ),
            SyncToken = "",
            domain = "",
            GivenName = "",
            DisplayName = "",
            BillWithParent = false,
            FullyQualifiedName = "",
            sparse = false,
            Active = true,
            Job = false,
            BalanceWithJobs = 0.0,
            PreferredDeliveryMethod = "",
            Taxable = false,
            PrintOnCheckName = "",
            Balance = 0.0,
            MetaData = CustomerMetaData(
                CreateTime = "",
                LastUpdatedTime = "",
            ),
        )
    }
}

@Serializable
data class PrimaryEmailAddr(
    val Address: String,
)

@Serializable
data class PrimaryPhone(
    val FreeFormNumber: String,
)

@Serializable
data class CustomerBillAddr(
    val City: String?,
    val Line1: String?,
    val PostalCode: String?,
    val Country: String? = null,
    val Lat: String? = null,
    val Long: String? = null,
    val CountrySubDivisionCode: String? = null,
    val Id: String? = null,
)

@Serializable
data class CustomerMetaData(
    val CreateTime: String,
    val LastUpdatedTime: String,
)
